export enum OrderEditRestrictionType {
	None,
	Draft,
	Reserved,
	Confirmed,
	PastBookingDeadline,
	PastMaterialDeadline,
	Invoiced,
	Cancelled
}
